import {LoaderSourceBO} from "./LoaderSourceBO";
import _ = require("lodash")
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";

export class LoaderSourceBOValidation {

    static ValidateFields(aBO: LoaderSourceBO): Promise<void> {
        const self = this;

        return new Promise((resolve, reject)=>{

            //Partition Size
            if(aBO.WB_LoaderSource.cif.LOADERSOURCE_TYPE === 'Table' || aBO.WB_LoaderSource.cif.LOADERSOURCE_TYPE === 'View'){
                if(aBO.WB_LoaderSource.cif.PARTITIONQUEUESIZE < 1 || aBO.WB_LoaderSource.cif.PARTITIONQUEUESIZE > 500000)
                    self.addMessage(aBO, "PrtSz", "Partition size must be btn 1 - 500000");
                else
                    aBO.ValidateMessageProvider.removeMessage('PrtSz')
            }

            //Validate Customer Level
            if(_.isEmpty(aBO.WB_LoaderSource.cif.CUSTOMER_LEVEL)){
                self.addMessage(aBO, "EmptyCustLevel", "Customer Level cannot be empty");
            }else{
                aBO.ValidateMessageProvider.removeMessage('EmptyCustLevel')
            }

            //Validate Product Level
            if(_.isEmpty(aBO.WB_LoaderSource.cif.PRODUCT_LEVEL)){
                self.addMessage(aBO, "EmptyPrdtLevel", "Product Level cannot be empty");
            }else{
                aBO.ValidateMessageProvider.removeMessage('EmptyPrdtLevel')
            }

            //Validate Period Type
            if(_.isNull(aBO.WB_LoaderSource.cif.WB_PERIODM_ID)){
                self.addMessage(aBO, "EmptyPrdType", "Period Type cannot be empty");
            }else{
                aBO.ValidateMessageProvider.removeMessage('EmptyPrdType')
            }
            resolve();
        })

    }

    private static addMessage(aBO: LoaderSourceBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}